window.UNIT_TYPE = {
    HOUR: 'HOUR',
    DAY: 'DAY',
}

window.UNIT_VALUE_CONTINUITY = {
    CONTINUOUS: 'CONTINUOUS',
    DISCRETE: 'DISCRETE'
}

window.PERIOD_TYPE = {
    DAY: 'DAY',
    WEEK: 'WEEK',
    CUSTOM: 'CUSTOM',
}

window.UNIT_VALIDATION_TYPE = {
    NON_WORKING_HOURS: 'NON_WORKING_HOURS',
    WORKING_HOURS_AND_SCHOOL_TIME: 'WORKING_HOURS_AND_SCHOOL_TIME',
    WORKING_HOURS: 'WORKING_HOURS',
}

window.PERIOD_REFERENCE_TYPE = {
    SHIFT_START: 'SHIFT_START',
    SHIFT_END: 'SHIFT_END',
}

window.PERIOD_LENGTH_TYPE = {
    HOUR: 'HOUR',
}

window.MINOR_RULE_TYPE = {
    IN_SESSION: 'IN_SESSION',
    NOT_IN_SESSION: 'NOT_IN_SESSION',
    GENERAL: 'GENERAL',
}

window.WORK_RULE_PROPERTIES_TYPES = {
    MAX_HOURS_PER_DAY: 'MAX_HOURS_PER_DAY',
    MAX_HOURS_PER_WEEK: 'MAX_HOURS_PER_WEEK',
    SHIFT_TIMES: 'SHIFT_TIMES',
    MAX_DAYS_PER_WEEK: 'MAX_DAYS_PER_WEEK',
    MAX_COMBINED_HOURS_PER_DAY: 'MAX_COMBINED_HOURS_PER_DAY',
    MAX_HOURS_PER_DAY_PERIOD: 'MAX_HOURS_PER_DAY_PERIOD',
    MIN_REST_HOUR_PER_WEEK: 'MIN_REST_HOUR_PER_WEEK',
    MIN_REST_HOUR_BETWEEN_SHIFTS: 'MIN_REST_HOUR_BETWEEN_SHIFTS',
};

window.MINOR_RULE_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};